import {
  CHANGE_MESSAGE_LAST_VISITED,
  FETCH_COURSES,
  LOGOUT_PWA,
  SET_MESSAGES,
} from "./pwaDataTypes";

const intitalState = {
  courses: [],
  taught_classes: [],
  messages: [],
  // selectedCourse: {},
};

const pwaDataReducer = (state = intitalState, action) => {
  switch (action.type) {
    case FETCH_COURSES:
      return {
        ...state,
        courses: action.payload.courses,
        taught_classes: action.payload.taught_classes,
      };
    case SET_MESSAGES:
      return {
        ...state,
        messages: [...action.payload, ...state.messages],
      };
    case CHANGE_MESSAGE_LAST_VISITED:
      return {
        ...state,
        messages: [...action.payload, ...state.messages],
      };
    case LOGOUT_PWA:
      return intitalState;
    default:
      return state;
  }
};

export default pwaDataReducer;
